export default "/images/326b44337e4c15c568ec76b14f4fe831.png";